const Logo = '/icons/Logo.png';
const CodingPc = '/images/CodingPc.png';
const Arencon = '/icons/companies/Arenco.png';
const Arabic = '/icons/companies/Arabic.png';
const Emaar = '/icons/companies/Emaar.png';
const Otis = '/icons/companies/Otis.png';
const Hutamaki = '/icons/companies/Hutmark.png';
const Mahindra = '/icons/companies/Mahindra.png';
const PcUser = '/icons/about/PcUser.png';
const Cloud = '/icons/services/Cloud.png';
const EcommerceDevelopment = '/icons/services/EcommerceDevelopment.png';
const MobileAppDevelopment = '/icons/services/MobileDevelopment.png';
const GameDevelopment = '/icons/services/GameDevelopment.png';
const CloudServices = '/icons/services/CloudServices.png';
const LogoFrame = '/icons/LogoFrame.png';
const Clutch = '/icons/footer/Clutch.png';
const GoodFirm = '/icons/footer/GoodFirm.png';
const carouselVideo1 = '/videos/1.mp4';
const carouselVideo2 = '/videos/2.mp4';
const carouselVideo3 = '/videos/3.mp4';
const PcImage = '/images/PcImage.png';
const InnovationMainImage = '/images/home/InnovationMain.png';
const Innovation1 = '/images/home/Innovation1.png';
const Innovation2 = '/images/home/Innovation2.png';
const Innovation3 = '/images/home/Innovation3.png';
const Innovation4 = '/images/home/Innovation4.png';
const Messages = '/icons/Messages.png';
const LeftOneFourthCircle = '/icons/services/LeftOneFourthCircle.png';
const RightOneFourthCircle = '/icons/services/RightOneFourthCircle.png';
const Circle = '/icons/services/Circle.png';
const BlueWebsite = '/icons/services/BlueWebsite.svg';
const Wellavi = '/icons/companies/Wellavi.webp';
const Getbee = '/icons/companies/Getbee.svg';
const MyScienceLand = '/icons/companies/MyScienceLand.png';
const Niobi = '/icons/companies/Niobi.svg';
const L2Air = '/icons/companies/L2Air.png';

export {
  Arabic,
  Arencon,
  BlueWebsite,
  Circle,
  Cloud,
  CloudServices,
  Clutch,
  CodingPc,
  EcommerceDevelopment,
  Emaar,
  GameDevelopment,
  Getbee,
  GoodFirm,
  Hutamaki,
  Innovation1,
  Innovation2,
  Innovation3,
  Innovation4,
  InnovationMainImage,
  L2Air,
  LeftOneFourthCircle,
  Logo,
  LogoFrame,
  Mahindra,
  Messages,
  MobileAppDevelopment,
  MyScienceLand,
  Niobi,
  Otis,
  PcImage,
  PcUser,
  RightOneFourthCircle,
  Wellavi,
  carouselVideo1,
  carouselVideo2,
  carouselVideo3,
};
